import React from "react";
import channelOne from "../images/channelone.jpg";
import jwi from "../images/jwiHomePage.jpg";
import mnig from "../images/mnig.JPG";
import mnig1 from "../images/2.JPG";
import mnig2 from "../images/3.JPG";


export default function Portfolio() {
    const [currentComponent, setCurrentComponent] = React.useState(<TopLevel />)

    function ChannelOne() {
        return(
            <div className="channelOne">
                <a target="_blank" href="https://www.helpingfeedpeople.org/"><img src={channelOne}></img></a>
                <div>
                    <h2>Channel One Regional Food Bank</h2>
                    <p>This is a current contract that I work on part time. Most of the work here is small edits, 
                        like creating new pages, editing menus, and writing analytics reports for their SEO
                        <br />
                        <br />
                        A major project I have helped on work was recreating their Empty Bowls PHP plugin. This plugin
                        leverages Gravity Forms, Bloomerang, and Wordpress to create a full order form spreadsheet that allows 
                        the employees of the food bank to organize their orders with the kitchen and distribute the orders to the
                        correct customer at their corresponding pickup time</p>
                </div>
            </div>
        )
    }

    function JWI() {
        return(
            <div className="jwi">
                <a target="_blank" href="https://www.jwinfinityconsulting.com/"><img src={jwi}></img></a>
                <div>
                    <h2>Jolene Wee Infinity Consulting</h2>
                    <p>Jolene and I share an alma mater, so this was a fun project to work on! JWI had been using the same website on weebly
                        for some time until they decided to upgrade to Wordpress and Bluehost. We revamped their website using Elementor and 
                        gave it a fresh new look. Feel free to check it out by clicking on the image to the left!
                    </p>
                </div>
            </div>
        )
    }

    function MNIG() {
        return(
            <div className="mnig">
                <div id="mnig-images">
                    <a target="_blank" href="https://mynewitguys.com/"><img src={mnig1}></img></a>
                    <a target="_blank" href="https://mynewitguys.com/"><img src={mnig2}></img></a>
                </div>
                <div>
                    <h2>ITGuys Team</h2>
                    <p>ITGuys was my first professional contract with web development! Here, I used React to make small script program built into their
                        website to help with new hires on their call queue! This section of the site is unfortunately private, but the images on the left 
                        should you give you a basic idea on how it worked.
                    </p>
                </div>
            </div>
        )
    }

    function TopLevel() {
        return(
            <div className="portfolio-container">
                <button onClick={() => setCurrentComponent(<ChannelOne />)}><img src={channelOne}></img>Channel One Regional Food Bank</button>
                <button onClick={() => setCurrentComponent(<JWI />)}><img src={jwi}></img>Jolene Wee infinity Consulting</button>
                <button onClick={() => setCurrentComponent(<MNIG />)}><img src={mnig}></img>ITGuys Team</button>
            </div>
        )
    }

    return (
        <div>
            <button onClick={() => setCurrentComponent(<TopLevel />)} className="portfolio-button">Portfolio</button>
            {currentComponent}
        </div>
    )
}